import { render, staticRenderFns } from "./preauth-form.vue?vue&type=template&id=4bab102c&scoped=true&"
import script from "./preauth-form.vue?vue&type=script&lang=js&"
export * from "./preauth-form.vue?vue&type=script&lang=js&"
import style0 from "./preauth-form.vue?vue&type=style&index=0&id=4bab102c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab102c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VRow,VTextField})
